import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import RadioGroup, { RadioGroupComponentProps } from "@insite/mobius/RadioGroup";
import Radio from "@insite/mobius/Radio";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import Select from "@insite/mobius/Select";

const mapStateToProps = (state: ApplicationState) => ({
    pagination: getProductListDataViewProperty(state, "pagination"),
});

const mapDispatchToProps = {
    addProductFilters,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ProductListSortSelectStyles {
    radioGroup?: FieldSetGroupPresentationProps<RadioGroupComponentProps>;
}

export const sortSelectStyles: ProductListSortSelectStyles = {
    radioGroup: {
        css: css`
            font-size: ${TYPOGRAPHY.size.base} !important;
            line-height: ${TYPOGRAPHY.lineHeight.base} !important;
            font-weight: ${TYPOGRAPHY.weight.mediumbold} !important;
            font-family: Roboto, sans-serif !important;
            color: #333333 !important;
            padding-left: 11px !important;
            border-bottom: 1px solid #E0DFE0 !important;
        `,
    },
};

const styles = sortSelectStyles;

const ProductListSortSelect = ({ addProductFilters, pagination }: Props) => {
    if (!pagination) {
        return null;
    }

    const onChangeSortHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        addProductFilters({ sort: event.target.value });
    };

    return (
        <RadioGroup
            {...(styles.radioGroup as any)}
            value={pagination.sortType}
            labelPosition="left"
            onChange={onChangeSortHandler}
            data-test-selector="productListSortSelect"
        >
            {pagination.sortOptions.map(sortOption => (
                <Radio key={sortOption.sortType} value={sortOption.sortType}>
                    {sortOption.displayName}
                </Radio>
            ))}
        </RadioGroup>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListSortSelect),
    definition: {
        group: "Product List",
        displayName: "NIS Sort Select Radio",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
